import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { MessageModel } from "@mynjhelps/common";
import { MessageService } from "@mynjhelps/message";
import { StorageService } from "@mynjhelps/storage";


@Injectable({
  providedIn: "root"
})
export class AccessGuard  {
  private accessMessageCode: string = "E0439";

  constructor(
    private router: Router,
    private storageService: StorageService,
    private messageService: MessageService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let access = this.storageService.getItem("access");
    return true;
    
  }
  
  private showMessage() {
    const errorMessages = JSON.parse(this.storageService.getItem("EMSG"));
    const messgae = new MessageModel();
    messgae.Code = "F";
    messgae.Description = errorMessages[this.accessMessageCode];
    this.messageService.ShowErrorDetails(messgae);
  }
}
